import React, { Component } from 'react';
import PropTypes from 'prop-types';
import './connections.less';
import { connectIntegration, disconnectIntegration } from '../../redux/actions/integrationsConnectionActions';
import boxIcon from './icons/box.png';
import BoxAuthenticator from "./BoxAuthenticator";
import { notify } from 'common/Notification';

class BoxSwitch extends Component {
  static defaultProps = {
    connectionId: null,
  };

  static propTypes = {
    dispatch: PropTypes.func.isRequired,
    connectionId: PropTypes.number,
    agreedToPricing: PropTypes.bool.isRequired,
  };

  state = {
    loading: false,
  };

  onClick = () => {
    const { connectionId } = this.props;

    if (connectionId === null) {
      this.setState({ loading: true});
      BoxAuthenticator()
        .login({ state: { redirect_host: window.location.host } }) // TODO adjust scopes to minimum required
        .then(
          ({ authResponse }) => {
            this.props.dispatch(connectIntegration('files', 'box', authResponse));
            this.setState({ loading: false });
          },
          (res) => {
            const { code, message } = res.error;
            this.setState({ loading: false });
            notify.error(`Error connecting to Box: [${code}] ${message || ''}`);
          }
        )
    } else {
      this.props.dispatch(disconnectIntegration(connectionId));
    }
  }

  render() {
    const { connectionId, agreedToPricing } = this.props;
    const iconCls = `kloudless-switch ${connectionId ? 'on' : ''} ${agreedToPricing ? '' : 'hidden'}`;

    return (
      <div className="kloudless-control-holder2" >
        <img className="kloudless-connection-icon"
             src={boxIcon} TODO
             alt="Box logo"
        />

        <div className={iconCls} onClick={this.onClick} >
          { this.state.loading
          && <i
            className={"fa fa-circle-o-notch fa-spin"}
            style={{ marginTop: '10px', marginLeft: '11px', fontSize: '11px' }}
          />}
        </div>
      </div>
    );
  }
}

export default BoxSwitch;



// WEBPACK FOOTER //
// ./src/Integrations/connections/BoxSwitch.jsx